




















































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class EmployeeQuotasSummaryView extends Vue {
  @Prop() summary: any;

  get visibleGroups() {
    if (!this.summary || !this.summary.groups) {
      return [];
    }
    return this.summary.groups.filter((g: any) => g && g.items && g.items.length > 0);
  }

  isCardsMode(group: any): boolean {
    if (!group) {
      return false;
    }
    if (group.useCardsLayout === true || group.UseCardsLayout === true) {
      return true;
    }
    const mode = String(group.displayMode || group.DisplayMode || "").toLowerCase();
    return mode === "cards";
  }
}
